var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 19.5V21.0625C15.5 21.5803 15.0803 22 14.5625 22H3.9375C3.41973 22 3 21.5803 3 21.0625V6.6875C3 6.16973 3.41973 5.75 3.9375 5.75H6.75V17.3125C6.75 18.5187 7.73129 19.5 8.9375 19.5H15.5ZM15.5 6.0625V2H8.9375C8.41973 2 8 2.41973 8 2.9375V17.3125C8 17.8303 8.41973 18.25 8.9375 18.25H19.5625C20.0803 18.25 20.5 17.8303 20.5 17.3125V7H16.4375C15.9219 7 15.5 6.57812 15.5 6.0625ZM20.2254 4.85043L17.6496 2.27457C17.4738 2.09877 17.2353 2 16.9867 2H16.75V5.75H20.5V5.51332C20.5 5.26469 20.4012 5.02624 20.2254 4.85043Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.a17eb5f7508ef414bd5470ce2da7b806.svg";
export { ForwardRef as ReactComponent };